


























































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LogoSelector from '@ui/LogoSelector'
import AddSecretBrandTrigger from './AddSecretBrandTrigger.coffee'

settings =
  name: 'AddSecretBrandTriggerModal'

  resources:
    brands:
      resourceName: 'brand'
      slug: 'brands'
      infinityScroll: false
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    store: ['marketplace']
    components: { Modal, RequestButton, LogoSelector }
    mixins: [AddSecretBrandTrigger.trigger()]

    data: ->
      type: 'brand'
      selectedBrand: {}

    computed:
      secretBrands: -> @marketplace?.secret_brands || {}
      availableBrands: -> (@brands || []).filter((b) => !@secretBrands?[b.domain])
      canNotAdd: -> !@modal.data?.domain?.length

    methods:
      modalData: ->
        logo: null
        domain: null
        name: null
        description: null
        category_tags: []

      hiTabBrand: ->
        @type = 'brand'
        @clearBrandInfo()

      hiTabOther: ->
        @type = 'other'
        @clearBrandInfo()
 
      hiSelectBrand: (brand) ->
        @modal.data.logo = brand.logo
        @modal.data.domain = brand.domain
        @modal.data.name = brand.name

      hiSelectLogo: (brand) ->
        @modal.data.logo = brand.logo
        @modal.data.domain = brand.domain
        @modal.data.name = brand.name

      clearBrandInfo: ->
        @selectedBrand = {}
        @modal.data.logo = null
        @modal.data.domain = null
        @modal.data.name = null
        @modal.data.description = null
        @modal.data.category_tags = []

    watch:
      'modal.show': ->
        @type = 'brand'
        @clearBrandInfo()

export default VueOptions.vue settings
